const MOUCHI_SPECIAL_CUSTOMER_CLAIM = "MouchiSpecialCustomer";

const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
    const [, payload] = token.split(".");
    if (!payload) return null;

    try {
        const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
        const padded = normalized.padEnd(
            normalized.length + ((4 - (normalized.length % 4)) % 4),
            "=",
        );
        return JSON.parse(window.atob(padded));
    } catch {
        return null;
    }
};

export const getMouchiSpecialCustomerFromToken = (accessToken: string): boolean => {
    const payload = decodeJwtPayload(accessToken);
    const claimValue = payload?.[MOUCHI_SPECIAL_CUSTOMER_CLAIM];

    return claimValue === true || String(claimValue).toLowerCase() === "true";
};
